import { MutationFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import type { ResidualTableValues } from './getLoanResidualIncome';

export interface SaveLoanResidualIncomeParams {
  loanId: string;
  /** Only what the reviewer changed: a cell sent here becomes theirs, so the
   *  server stops recomputing it. */
  values?: Record<string, unknown>;
  tables?: ResidualTableValues;
}

const saveLoanResidualIncome: MutationFunction<
  { success: boolean },
  SaveLoanResidualIncomeParams
> = async ({ loanId, values, tables }) => {
  if (isMockServices()) return await mock({ success: true });

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{ success: boolean }>(
    `/loans/${loanId}/residual-income`,
    {
      method: 'PUT',
      body: {
        ...(values ? { values } : {}),
        ...(tables ? { tables } : {}),
      },
    },
  );
  return response.data ?? { success: false };
};

export default saveLoanResidualIncome;
